import { useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../appProvider/contextProvider';
import Loader from '../../components/Loader/loader';
import { ERRORS } from '../../constants/AppConstants';
import {changePassword}  from '../../services/userService';


const PasswordChange = () => {

    const history = useHistory();

    const [new_password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    
    const [passwordError, setPasswordError] = useState(null);
    const [confirmPasswordError, setConfirmPasswordError] = useState(null);

    const {isFetching, isMutating} = useAppContext();
    const [viewPassword, setViewPassword] = useState(false);
    const [viewChangePassword, setViewChangePassword] = useState(false);

    const handelPasswordValidation = () => {
        if(new_password.trim().length <= 0 ) {
            setPasswordError(ERRORS.PASSWORD_REQUIRED);
        } else if(new_password.length > 0 && new_password.length < 8) {
            setPasswordError(ERRORS.PASSWORD_LENGTH);
        } else {
        setPasswordError(null);
        }
    }

    const handelConfirmPasswordValidation = () => {
        if(confirm_password.trim().length <= 0 ) {
            setConfirmPasswordError(ERRORS.PASSWORD_REQUIRED);
        }
        else if(confirm_password !== new_password ) {
            setConfirmPasswordError(ERRORS.PASSWORD_MATCH_ERROR);
        }
        else {
            setConfirmPasswordError(null);
        }
    }


    const save = useMutation((event) => {
        event.preventDefault();
        return changePassword({new_password, confirm_password});
    }, {
        onSuccess: ((userData) => {
            if(userData.errors) {
                if(userData.errors === 'previous_password') {
                    toast.error(ERRORS.PREVIOUS_PASSWORD,  {
                        autoClose: 5000,
                        position: 'bottom-right'
                    });
                }
            } else {
                toast.success(userData.detail,  {
                    autoClose: 5000,
                    position: 'bottom-right'
                });
            }
            resetForm();
            // reset();
            // history.push('/login');
        }),
        onError: ((error) => {
            // toast.error(error.message);
        })
    });


    const isChangePasswordDisabled = () => {
        return new_password.length <= 0 || confirm_password.length <= 0 || passwordError || confirmPasswordError;
    }

    const resetForm = () => {
        setPassword('');
        setPasswordError(null);
        setConfirmPassword('');
        setConfirmPasswordError(null);
    }

    return <> <div className={!!(isMutating || isFetching) ? 'row no-gutters page-container loader full-height':  'page-container full-height'}>
    {!!(isMutating || isFetching) && <Loader />}
    <div className="panel full-height">
        <div className="panel-header">
            <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick={() => history.push('/profile')}  ></i>Change Password</h3>
            </div>                                
        </div>
        <div className="panel-body scrollable_y">
            <div className="row">
                <div className="col-12 col-lg-6">
                    <h6 className="mb-3 medium text-dark">Change your password</h6>
                    <div className="form-group">
                        <label className="form-label">Password</label>
                        <div className="input-addon input-group-left">
                            <input 
                                type={viewPassword ? 'text': 'password'}
                                value={new_password}
                                onChange={({target}) => setPassword(target.value)}
                                onBlur={handelPasswordValidation}
                                placeholder="Enter Your Password" 
                                className="form-control pl-3"
                            />
                            <button type="button" className="btn btn-neutral">
                            <i 
                                className={viewPassword ? 'icon icon-password-mask' : 'icon icon-eye'}
                                onClick={() => setViewPassword(!viewPassword)}
                            ></i></button>
                        </div>
                        {passwordError && <span className="error-message">{passwordError}</span>}
                    </div>
                    <div className="form-group">
                        <label className="form-label">Confirm Password</label>
                        <div className="input-addon input-group-left">
                            <input 
                                type={viewChangePassword ? 'text': 'password'}
                                placeholder="Confirm Your Password" 
                                className="form-control pl-3"
                                value={confirm_password}
                                onChange={({target}) => setConfirmPassword(target.value)}
                                onBlur={handelConfirmPasswordValidation}
                            />
                            <button type="button" className="btn btn-neutral">
                            <i 
                                className={viewChangePassword ? 'icon icon-password-mask' : 'icon icon-eye'}
                                onClick={() => setViewChangePassword(!viewChangePassword)}
                            ></i></button>
                        </div>
                        {confirmPasswordError && <span className="error-message">{confirmPasswordError}</span>}
                    </div>
                    <button 
                        className="btn btn-sm btn-primary" 
                        disabled={isChangePasswordDisabled()} 
                        onClick={save.mutate}>Save</button>
                </div>
            </div>                            
        </div>
    </div>
</div>
</>
}

export default PasswordChange;